import { PageFrame } from "../../components/page_frame";
import { InventoryHealthContainer } from "./container";

export default function InventoryHealthPage() {
  return (
    <PageFrame>
      <InventoryHealthContainer />
    </PageFrame>
  );
}
